import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Button, Container } from 'react-bootstrap';
import {
  DataTable,
  DataTableItem,
  Loader,
  SectionHeader,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  AccountingGroupDetails,
  AccountingsQueryFilters,
  addPurchaseAccountingGroupAsync,
  getAllPurchaselAccountingGroupsAsync,
  selectPurchaseAccountingGroups,
  selectPurchaseAccountingGroupsLoadingStatus,
} from './accountingSlice';
import { LOADING_STATUS } from '../../common/constants';

function PurchaseAccountingGroups() {
  const history = useNavigate();
  const dispatch = useAppDispatch();
  const [hasSearchBeenMade, setHasSearchBeenMade] = useState<boolean>(false);
  const accountingGroups = useAppSelector(selectPurchaseAccountingGroups);
  const accountingGroupsLoadingStatus = useAppSelector(
    selectPurchaseAccountingGroupsLoadingStatus,
  );

  const [filtering, setFiltering] = useState<AccountingsQueryFilters>({
    pageSize: 200,
    pageNumber: 1,
    culture: 'fi_FI',
  });
  const [accountingGroupsListItems, setAccountingGroupsListItems] = useState<
    DataTableItem[]
  >([]);

  // calls actual search, which calls internal getAllAccountingGroupsAsync Async
  // and that is then routed to backend
  const doSearch = () => {
    dispatch(getAllPurchaselAccountingGroupsAsync(filtering));
  };

  useEffect(() => {
    doSearch();
    setHasSearchBeenMade(true);
  }, []);

  useEffect(() => {
    if (accountingGroups && accountingGroups.length > 0) {
      const formattedAccountingGroupsList: DataTableItem[] = [];
      accountingGroups?.forEach(item => {
        formattedAccountingGroupsList.push({
          ItemId: item.id,
          Items: [item.name],
          Url: `/accounting/purchaseaccountinggroups/${item.id}`,
        });
      });
      setAccountingGroupsListItems(formattedAccountingGroupsList);
    }
  }, [accountingGroups]);

  const handleAddClick = () => {
    const data = {
      id: '',
      name: '',
    } as AccountingGroupDetails;
    dispatch(addPurchaseAccountingGroupAsync(data)).then(res => {
      history(`/accounting/purchaseaccountinggroups/${res.payload}`);
    });
  };

  // draws elements to browser
  return (
    <>
      <Helmet>
        <title>Kirjanpitotilit - Haku</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Kirjanpito ja Alv-määritykset']}
          Title="Kirjanpitotilit - Haku"
        />

        <Loader
          IsLoading={accountingGroupsLoadingStatus === LOADING_STATUS.LOADING}
        />

        {accountingGroupsLoadingStatus === LOADING_STATUS.IDLE &&
          accountingGroupsListItems.length > 0 && (
            <DataTable Header={['Nimi']} Items={accountingGroupsListItems} />
          )}

        {accountingGroupsLoadingStatus === LOADING_STATUS.IDLE &&
          accountingGroupsListItems.length < 1 &&
          hasSearchBeenMade && <p>Ei kirjanpitotilejä.</p>}
      </Container>
    </>
  );
}

export default PurchaseAccountingGroups;
